import React, { useEffect, useState } from "react";
import "./colaboradores.css";

/**
 * Muestra los logos de colaboradores almacenados en GridFS
 * (colaboradores.files / colaboradores.chunks) vía /api/colaboradores.
 * Solo visualiza: SIN subir, SIN eliminar, SIN editar.
 */
export default function Colaboradores() {
  const API = "/api/colaboradores";
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setError("");
        const r = await fetch(API);
        if (!r.ok) throw new Error(await r.text());
        const data = await r.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        setError(e.message || "No se pudieron cargar los colaboradores");
        setItems([]);
      }
    })();
  }, []);

  return (
    <div className="colaboradores-wrap">
      <header className="colaboradores-header">
        <h2 className="title">Colaboradores</h2>
      </header>

      {error && <div className="colab-error">{error}</div>}

      <section className="colaboradores-grid">
        {items.length === 0 && <div className="colab-empty">No hay colaboradores.</div>}
        {items.map((it) => (
          <figure className="colab-item" key={it._id} title={it.nombre || it.filename}>
            <img
              src={`${API}/${it._id}`}
              alt={it.nombre || it.filename}
              loading="lazy"
              onError={(e) => (e.currentTarget.style.visibility = "hidden")}
            />
          </figure>
        ))}
      </section>
    </div>
  );
}
